
<div class="col-12 flex mt-2">
  <div class="col-12 border border-info rounded" #topDiv>
    <div class="col-12 flex">
      <div class="col-3 ui-inputgroup" style="width: 35%;">
        <button pButton class="noHover labelButton" label="WorkFlow" style="height: 35px;"></button>
        <p-dropdown [options]="workFlows" placeholder="Select Workflow" [(ngModel)]="selectedWorkflow" (onChange)="onWorkflowChange()"></p-dropdown>
      </div>
      <div class="col-3 ui-inputgroup">
        <button pButton style="height: 35px;margin-top: 4px;" class="theme-button noHover labelButton" type="button" label="Product"></button>
        <p-multiSelect [options]="productList" (onChange)="onApplyFilter($event)" [(ngModel)]="valueToSearchforProduct"
         [style]="{'width':'200px','margin-top': '3px','height': '36px'}">
          <ng-template let-item pTemplate="selectedItem">
            <span style="vertical-align:middle">{{item.label}}</span>
          </ng-template>
          <ng-template let-status pTemplate="item">
            {{status.label}}
          </ng-template>
        </p-multiSelect>
        </div>
    </div>
    <div class="table">
    <div class="row col-12 flex container-fluid">
      <div class="row cell" >
          <div class="col-6" style="margin-top: 16px;padding: 0px;padding-left: 2%;width: 32%;">
          <div class="col">
            <div class="row">
              <p-table [value]="displayBatches" selectionMode="multiple" [scrollable]="true" scrollHeight="80vh"
              (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)"
              [loading]="displayLoading" [(selection)]="singleSelectedBatch">
              <ng-template pTemplate="header">
                <tr>
                  <th scope="col" style="width: 80%;" class="text-center">Define Merge</th>
                  <th scope="col" style="width: 20%; " class="text-center">
                    <em class="fa fa-refresh" (click)="filterBatchStatus()"></em>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-batch>
                <tr [pSelectableRow]="batch">
                  <td style="width: 60%;" class="text-center">
                    {{batch?.batchID}}</td>
                </tr>
              </ng-template>
            </p-table>
            <div>
            <div class=" row col-5">
            <div class="mergeComp">
            <div class="col p-0 ui-fluid centered">
              <div class="col-12 flex ">
                <div>
                  <div class="ui-inputgroup" style="width: 200%;margin-top: 20px;">
                    <button pButton class="noHover labelButton" type="button" label="A1"></button>
                    <input class="h-2rem" *ngIf="allowA1" type="text" autocomplete="off" size="25" placeholder="Batch ID"
                      id="A1" [(ngModel)]="a1BatchCode" readonly>
                      <span>
                        <em class="fa fa-trash" style="font-size: 1.8em;" (click)="onSelectedBatchDelete(a1BatchCode)"
                          [hidden]="a1BatchCode== ''"></em>
                      </span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="col-12 flex">
                <div>
                  <div class="ui-inputgroup" style="width: 200%;margin-top: 20px;">
                    <button pButton class="noHover labelButton" type="button" label="A2"></button>
                    <input class="h-2rem" *ngIf="allowA2" type="text" autocomplete="off" placeholder="Batch ID" id="A2"
                      size="25" [(ngModel)]="a2BatchCode" readonly>
                      <span>
                        <em class="fa fa-trash" style="font-size: 1.8em;" (click)="onSelectedBatchDelete(a2BatchCode)"
                          [hidden]="a2BatchCode== ''"></em>
                      </span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="col-12 flex ">
                <div>
                  <div class="ui-inputgroup" style="width:  200%;margin-top: 20px;">
                    <button pButton class="noHover labelButton" type="button" label="B1"></button>
                    <input class="h-2rem" *ngIf="allowB1" type="text" autocomplete="off" placeholder="Batch ID" id="B1"
                      size="25" [(ngModel)]="b1BatchCode" readonly>
                      <span>
                        <em class="fa fa-trash"  style="font-size: 1.8em;" (click)="onSelectedBatchDelete(b1BatchCode)"
                          [hidden]="b1BatchCode== ''"></em>
                      </span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="col-12 flex ">
                <div>
                  <div class="ui-inputgroup" style="width:  200%;margin-top: 20px;">
                    <button pButton class="noHover labelButton" type="button" label="B2"></button>
                    <input class="h-2rem" *ngIf="allowB2" type="text" autocomplete="off" placeholder="Batch ID" id="B2"
                      size="25" [(ngModel)]="b2BatchCode" readonly>
                      <span>
                        <em class="fa fa-trash" style="font-size: 1.8em;" (click)="onSelectedBatchDelete(b2BatchCode)"
                          [hidden]="b2BatchCode== ''"></em>
                      </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 flex ui-inputgroup" style="width: 335%;padding-left: 7px;margin-top: 20px;">
              <button pButton style="background: #2399e5;" class=" noHover labelButton" type="button" label="New Batch"></button>
              <input type="text" size="25" autocomplete="off" placeholder="Batch ID" id="mergeBatch"
              (blur)="checkBatchExistance(mergeBatchId)" [(ngModel)]="mergeBatchId">
            </div>
            <div class="col-12 flex ui-md-3" style="padding-left: 3%;">
                <button pButton type="submit" class="buttonsRound" (click)="onSubmit()"
                  style="margin-top: 26%;"
                  [disabled]="!((b2BatchCode || b1BatchCode || a1BatchCode || a2BatchCode) && (mergeBatchId && mergeBatchId.trim() != '') && !isExist)"
                  label="Define Merge"></button>
              </div>
              </div>
          </div>
        </div>
     </div>
    </div>
  </div>
  <div class="cell col-7">
    <div class="col-12 flex">
      <div class="col-2" style="margin-top: 6%;">
        <button pButton type="submit" class="buttonsRound" (click)="undoMerge()" [disabled]="!mergeSelectedBatch"
          label="Undo Merge"></button>
      </div>
      <div class=" col-9" style="padding-left: 12%;width: 83%;padding-top: 0%;">
        <p-table [value]="mergedBatchList" selectionMode="single" [scrollable]="true" scrollHeight="60vh"
          [loading]="loading" [(selection)]="mergeSelectedBatch">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col" style="width: 80%; text-align: center" class="batch text-center">Merge Batches</th>
              <th scope="col" style="width: 20%; text-align: center" class="batch">
                <em class="fa fa-refresh" (click)="getMergedBatches()"></em>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-batch>
            <tr [pSelectableRow]="batch">
              <td style="width: 60%; text-align: center">
                {{batch}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="col-11 flex justify-content-end" style="margin-top: 24%;width: 99%;">
      <button pButton class="buttonsRound float-right" (click)="completeMerge()" [disabled]="!mergeSelectedBatch"
        label="Complete Merge"></button>
    </div>
  </div>
</div>
</div>
</div>
</div>
</div>

<p-blockUI [blocked]="blocked">
  <div>
    <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>
